import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-paop',
  templateUrl: './paop.component.html',
  styleUrls: ['./paop.component.scss']
})
export class PaopComponent {

  constructor() { }

}
